import type { Prisma } from "@/schemas/generated/prisma/client";
import { teamConfig } from "./team-config";

export const BASEBALL_TAGS = [
	...new Set([
		"野球",
		"プロ野球",
		"NPB",
		"MLB",
		"メジャー",
		"大谷翔平",
		"高校野球",
		"侍ジャパン",
		"野球議論",
		...Object.values(teamConfig).flatMap((team) => team.tags),
	]),
];
export type FeedKind = "baseball" | "talk" | "all";

/** 不明なフィード指定は野球に戻す。副作用なし。 */
export function feedKind(value: string): FeedKind {
	return value === "talk" || value === "all" ? value : "baseball";
}

/** 野球は野球・球団タグのいずれか、雑談は雑談タグを持つ野球以外の記事を返す。DB操作なし。 */
export function feedWhere(kind: FeedKind): Prisma.NanJArticlesWhereInput {
	const baseball = { tags: { some: { tag: { tag_name: { in: BASEBALL_TAGS } } } } };
	if (kind === "all") return {};
	if (kind === "talk")
		return { AND: [{ tags: { some: { tag: { tag_name: "雑談" } } } }, { NOT: baseball }] };
	return baseball;
}

/**
 * 球団slugに対応する別名タグのいずれかを持つ記事の条件を返す。
 * 入力は正規slug。未知・空・継承プロパティの名前は空集合に限定し、全記事へ広げない。
 * 戻り値はPrisma検索条件。副作用・例外なし。設定の配列は複製して外部変更を防ぐ。
 */
export function teamWhere(slug: string): Prisma.NanJArticlesWhereInput {
	if (!Object.hasOwn(teamConfig, slug)) return { article_id: { in: [] } };
	return { tags: { some: { tag: { tag_name: { in: [...teamConfig[slug].tags] } } } } };
}
